module.exports = __webpack_public_path__ + "static/media/image_1.65418bf7.png";